import { render, staticRenderFns } from "./desensitizeList.vue?vue&type=template&id=0b0484b0&scoped=true&"
import script from "./desensitizeList.vue?vue&type=script&lang=js&"
export * from "./desensitizeList.vue?vue&type=script&lang=js&"
import style0 from "./desensitizeList.vue?vue&type=style&index=0&id=0b0484b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0484b0",
  null
  
)

export default component.exports